/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box} from '@mui/material';
import {
  convertSlugToString,
  convertToSlug,
  GetRouter,
  handelRenderConfigDigitalRiverCheckout,
  handleConvertToLocaleContentful,
  handleRenderPrice,
} from '~/utils';
import EStoreProductDetail from '@wearesection/bandai-react-components/organisms/EStoreProductDetail';
import {ReactNode, useEffect, useRef, useState} from 'react';
import {setProductListRecentlyID} from '~/redux-toolkit/productListRecentlySlice';
import {useDispatch, useSelector} from 'react-redux';
import EStoreProductDetailRecentlyOrganisms from '~/components/wrapper/organisms/store-product-recently-viewed';
import EStoreProductDetailGameSpecsOrganisms from '~/components/wrapper/organisms/store-product-detail-game-specs';
import EStoreYouMayLikeOrganisms from '~/components/wrapper/organisms/store-you-may-like';
import productsApi from '~/pages/api/services/products-api';
import {IconLoading} from '@wearesection/bandai-react-components/atoms/Icon';
import {IOption} from '@wearesection/bandai-react-components/organisms/EStoreProductDetail/Option';
import {usePageSetting} from '~/providers/page-context.provider';
import cartApi from '~/pages/api/services/cart-api';

import RenderNextLink from '~/components/wrapper/atoms/render-next-link';
import {PLACEHOLDER_IMG} from '~/constants';
import {addListCart} from '~/redux-toolkit/cartSlice';
import EStoreProductDetailAboutGameOrganisms from '~/components/wrapper/organisms/store-product-detail-about-game';
import EStoreProductDetailDownloadableOrganisms from '~/components/wrapper/organisms/store-product-detail-downloadable';
import {handleFormatPlatforms} from '../index.page';
import RenderNextImage from '~/components/wrapper/atoms/render-next-image/render-next-image';
import {getCookie, setCookie} from 'cookies-next';
import {cloneDeep} from 'lodash';
import EStoreProductDetailCompareEditionsOrganisms from '~/components/wrapper/organisms/store-product-detail-compare-edition/store-product-detail-compare-edition';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '~/pages/[[...slug]]/index.page';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import {checkPrices} from '~/utils/sentry-helper';

export const handleFormatValuePlatform = (value: string) => {
  if (!value) return value;
  switch (value.toLocaleLowerCase()) {
    case 'playstation 4':
    case 'ps4':
      return 'ps4';
    case 'xbox one':
      return 'xboxo';
    case 'xbox series x':
      return 'xbox';
    case 'xbox series s/x':
    case 'xbox series x|s':
    case 'xbox series s|x':
      return 'xboxxs';
    case 'xbox series s':
      return 'xboxs';
    case 'playstation 5':
    case 'ps5':
      return 'ps5';
    case 'pc':
    case 'steam':
      return 'steam';
    case 'nintendo switch':
      return 'nintendo';
    default:
      return '';
  }
};

const ProductDetail = () => {
  const route = GetRouter();
  const {locale} = route;
  const {slug, to} = route.query;
  const deSlug = convertSlugToString((slug as string) || '');
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const dispatch = useDispatch();
  const productListRecentlyID = useSelector(
    (state: any) => state?.productListRecently?.productListRecentlyID ?? []
  );
  const listCartData = useSelector((state: any) => state?.cart?.listCart || []);

  const [id, setId] = useState<any>('');
  const [title, setTitle] = useState<any>('');
  const [dataGame, setDataGame] = useState<any>({});
  const [listThumbnail, setListThumbnail] = useState<any[]>([]);
  const [optionsData, setOptionData] = useState<IOption | any>({});
  const [platformList, setPlatformList] = useState<any[]>([]);

  const [platform, setPlatform] = useState<any>();
  // const [platformTitle, setPlatformTitle] = useState<any>();

  const [type, setType] = useState<any>('');
  // const [typeTitle, setTypeTitle] = useState<any>('');
  const [listType, setListType] = useState<any[]>([]);
  const [edition, setEdition] = useState<any>(null);
  const [qty, setQty] = useState<any>(1);
  const [price, setPrice] = useState<any>('');
  const [salePrice, setSalePrice] = useState<any>('');

  const [priceEditionList, setPriceEditionList] = useState<any[]>([]);
  const [listCategories, setListCategories] = useState<any[]>([]);
  const [variants, setVariants] = useState<any[]>([]);
  const [sku, setSku] = useState<string>('');
  const [maxItemOrder, setMaxItemOrder] = useState<number>(5);
  const [disableBtn, setDisableBtn] = useState<boolean>(false);
  const [stateAdded, setStateAdded] = useState<boolean>(false);
  const [isProductDlc, setIsProductDlc] = useState<boolean>(true);
  const [listProductRelated, setListProductRelated] = useState<any[]>([]);
  const [listProductDLC, setListProductDLC] = useState<any[]>([]);
  const [listProductGame, setListProductGame] = useState<any[]>([]);
  const [hadCompareEdition, setHadCompareEdition] = useState<boolean>(false);

  // state tab
  const [isFeatured, setIsFeatured] = useState<boolean>(false);
  const [isPreOrder, setIsPreOrder] = useState<boolean>(false);
  const [isSoldOut, setIsSoldOut] = useState<boolean>(false);
  const [highestDiscount, setHighestDiscount] = useState<number>(0);

  const [description, setDescription] = useState<ReactNode>('');
  const [loadingBtnAddCart, setLoadingBtnAddCart] = useState<boolean>(false);
  const [loadingBtnBuyNow, setLoadingBtnBuyNow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [mpnSku, setMpnSku] = useState<string>('');
  const refTimeOut = useRef<any>();
  const refLengthListThumbnail = useRef<number>(0);
  const refId = useRef<any>('');
  const refTimeOutScroll = useRef<any>();

  // get detail product for slug
  useEffect(() => {
    setLoading(true);
    if (typeof window !== 'undefined') {
      if (Object.keys(dataTranslation)?.length) {
        productsApi
          .getProductItem('', deSlug, handleConvertToLocaleContentful(locale as string))
          .then((res: any) => {
            if (res?.status !== 200) {
              throw res;
            }
            const {data} = res;
            if(!data?.isGame) {
              if (data?.isMerchandise){
                return route.push(`/${route.locale}/store/merchandise/${route.query.slug}`);

              }
              let related_products = data?.related_products ? data.related_products : []
              if(related_products?.length > 0 && related_products[0] !== -1) {
                productsApi
                  .getProductItem(
                    related_products.shift()
                  )
                  .then((res: any) => {
                    if (res?.status !== 200) {
                      throw res;
                    }
                    const {data} = res;
                    if (data?.title) {
                      return route.push(`/${route.locale}/store/games/${convertToSlug(data.title)}`); ;
                    }
                  })
                  .catch((e: any) => {
                    console.log(e?.response?.message);
                  })

                  return;
              }
              if(data?.isGift){
                return route.push(`/${route.locale}/store/games`)
              }
            } 
            if (!Object.keys(data).length) {
              return route.push(`/${route.locale}/store/games`);
            }

            setDataGame(data);
            setIsPreOrder(!!data?.isPreOrder);
            setId(data?.id || '');
            setLoading(false);
            refId.current = data?.id;
            setIsProductDlc(data?.isDLC || false);
            setListProductRelated(
              data?.related_products?.includes?.(-1) ? [] : data?.related_products || []
            );
            setListCategories(data?.categories || 0);
            setSku(data?.sku);
            setDescription(data?.description ?? '');
            handleFormatListThumbnail(data?.videos || [], data?.images || []);
            setIsFeatured(!!data?.isFeatured);
            setHighestDiscount(data?.highest_discount || 0);
            setIsSoldOut(data?.isSoldOut || false);
            setPrice(
              `${handleRenderPrice(data?.sale_price || data?.default_price || '00', null, locale)}`
            );
            let platforms: any[] = [];
            let type: any[] = [];

            if (data?.options?.length) {
              const {options} = data;
              options.map((option: any) => {
                if (option?.display_name === 'Platform') {
                  platforms = handleFormatPlatform(option, data?.isDLC || false) || [];
                }
                if (option?.display_name === 'Type') {
                  type = handleFormatType(option) || [];
                }
              });
            }
            setListType(type);
            const newOptions = {
              tabList: [],
              title: data?.title || '',
              platform: {
                title: dataTranslation['game-detailed-game-info-release-platform'],
                platformList: [],
              },
              typeOption: {
                title: dataTranslation['estore-products-detail-title-type'],
                typeList: type,
              },
              itemSelectType: {
                titleType: '',
                id: '',
              },
              typeEdition: {
                title: dataTranslation['estore-products-detail-title-edition'] || 'Edition',
                // dataTranslation['estore-products-detail-title-compare-edition'] || 'Compare',
                editionList: [],
              },
              contentModal: {
                title: dataTranslation['estore-title-modal-noti-not-enough'] || '',
                description: dataTranslation['estore-description-modal-noti-not-enough'] || '',
                titleOut: dataTranslation['estore-title-modal-noti-not-enough-out'] || '',
                descriptionOut:
                  dataTranslation['estore-description-modal-noti-not-enough-out'] || '',
                buttonProps: {
                  label: dataTranslation['estore-label-btn-modal-noti-not-enough'] || '',
                  variant: 'secondaryBlack',
                },
              },
            };
            setPlatformList(platforms);
            setTitle(data?.title);
            setOptionData(newOptions);
            if (data?.variants?.length) {
              const newVariants = data.variants.filter((item: any) => {
                item.inventory_level =
                  item.inventory_level + handleGetInventoryLocation(item?.inventory_location || []);
                if (data?.isDLC) {
                  return item;
                }
                return (
                  item.purchasing_disabled === false
                  // item.type_label === 'Digital' ||
                  // item.sku?.includes('http')
                );
              });
              checkPrices(newVariants, "store-games-slug");
              setVariants(newVariants || []);
            }
          })
          .catch(err => {
            console.log('err', err);
            route.push(`/${route.locale}/store/games`);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deSlug, JSON.stringify(dataTranslation)]);

  // get list products DLC
  useEffect(() => {
    setListProductDLC([]);
    setListProductGame([]);
    if (typeof window !== 'undefined' && !isProductDlc && Object.keys(dataTranslation)?.length) {
      if (listProductRelated?.length) {
        setLoading(true);
        productsApi
          .getListProductsForId(
            listProductRelated.join(),
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res?.status !== 200) {
              throw res;
            }
            const {data} = res?.data;
            if (data?.length) {
              const newDataDLC = data
                .filter((item: any) => !!item.isDLC)
                .map((product: any) => {
                  return {
                    id: product?.id,
                    title: product?.title,
                    mainImage: product?.mainImage ?? PLACEHOLDER_IMG,
                    description: product?.description || '',
                    platformList: !product?.platforms?.length
                      ? []
                      : product?.platforms.map((item: any) => {
                          const title = handleFormatValuePlatform(item?.title);
                          return {
                            titleIcon: title,
                            value: title,
                            id: item?.id,
                          };
                        }),
                    linkHref: `/store/games/${convertToSlug(product?.title || '')}`,
                    buttonProps: {
                      variant: 'secondary',
                      label: dataTranslation['game-detailed-sub-nav-buy'] || 'Buy',
                    },
                    priceProps: {
                      label: dataTranslation['product-from'] || 'From',
                      currency: '',
                      amount: handleRenderPrice(
                        product?.sale_price || product?.default_price || '00',
                        null,
                        locale
                      ),
                      noFormat: true,
                    },
                    nextLink: (href: string, child: ReactNode) => (
                      <RenderNextLink
                        href={`${href}`}
                        child={child}
                        setting={{scroll: true, shallow: true}}
                      />
                    ),
                  };
                });
              const newDataGame = data
                .filter((item: any) => !item.isDLC)
                .map((product: any) => {
                  return {
                    id: product?.id,
                    title: product?.title,
                    mainImage: product?.mainImage || PLACEHOLDER_IMG,
                    mainImageNext: (
                      <RenderNextImage
                        src={product?.mainImage || PLACEHOLDER_IMG}
                        width={300}
                        height={200}
                      />
                    ),
                    isMerchandise: product?.isMerchandise ?? false,
                    href: product?.isMerchandise
                      ? `/store/merchandise/${convertToSlug(product?.title)}`
                      : `/store/games/${convertToSlug(product?.title)}`,
                    nextLink: (href: string, child: ReactNode) => (
                      <RenderNextLink href={href} child={child} />
                    ),
                    listIcon: product?.platforms ? handleFormatPlatforms(product?.platforms) : [],
                    valuePrice: {
                      label: dataTranslation['product-from'] || '',
                      price: `${handleRenderPrice(product?.sale_price || '00', null, locale)}`,
                      priceOld:
                        product?.sale_price === product?.default_price
                          ? ''
                          : `${handleRenderPrice(product?.default_price || '00', null, locale)}`,
                    },
                  };
                });
              setListProductDLC(newDataDLC || []);
              setListProductGame(newDataGame || []);
              setLoading(false);
            }
          })
          .catch((e: any) => {
            console.log(e?.response?.message);
          })
          .finally(() => {
            setLoading(false);
          });
        return;
      }
      if (listCategories?.length && !listProductRelated?.length) {
        setLoading(true);
        productsApi
          .getListProductsSameGenre(
            listCategories.join(','),
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res?.status !== 200) {
              throw res;
            }
            const {data} = res?.data;
            if (data?.length) {
              const newDataDLC = data
                .filter((item: any) => !!item.isDLC && item?.id !== id)
                .map((product: any) => {
                  return {
                    id: product?.id,
                    title: product?.title,
                    mainImage: product?.mainImage ?? PLACEHOLDER_IMG,
                    description: product?.description || '',
                    platformList: !product?.platforms?.length
                      ? []
                      : product?.platforms.map((item: any) => {
                          const title = handleFormatValuePlatform(item?.title);
                          return {
                            titleIcon: title,
                            value: title,
                            id: item?.id,
                          };
                        }),
                    linkHref: `/store/games/${convertToSlug(product?.title || '')}`,
                    buttonProps: {
                      variant: 'secondary',
                      label: dataTranslation['game-detailed-sub-nav-buy'] || 'Buy',
                    },
                    priceProps: {
                      label: dataTranslation['product-from'] || 'From',
                      currency: '',
                      amount: handleRenderPrice(
                        product?.sale_price || product?.default_price || '00',
                        null,
                        locale
                      ),
                      noFormat: true,
                    },
                    nextLink: (href: string, child: ReactNode) => (
                      <RenderNextLink
                        href={`${href}`}
                        child={child}
                        setting={{scroll: true, shallow: true}}
                      />
                    ),
                  };
                });
              const newDataGame = data
                .filter((item: any) => !item.isDLC && item?.id !== id)
                .map((product: any) => {
                  return {
                    id: product?.id,
                    title: product?.title,
                    mainImage: product?.mainImage || PLACEHOLDER_IMG,
                    mainImageNext: (
                      <RenderNextImage
                        src={product?.mainImage || PLACEHOLDER_IMG}
                        width={300}
                        height={200}
                      />
                    ),
                    isMerchandise: product?.isMerchandise ?? false,
                    href: product?.isMerchandise
                      ? `/store/merchandise/${convertToSlug(product?.title)}`
                      : `/store/games/${convertToSlug(product?.title)}`,
                    nextLink: (href: string, child: ReactNode) => (
                      <RenderNextLink href={href} child={child} />
                    ),
                    listIcon: product?.platforms ? handleFormatPlatforms(product?.platforms) : [],
                    valuePrice: {
                      label: dataTranslation['product-from'] || '',
                      price: `${handleRenderPrice(product?.sale_price || '00', null, locale)}`,
                      priceOld:
                        product?.sale_price === product?.default_price
                          ? ''
                          : `${handleRenderPrice(product?.default_price || '00', null, locale)}`,
                    },
                  };
                });
              setListProductDLC(newDataDLC || []);
              setListProductGame(newDataGame || []);
              setLoading(false);
            }
          })
          .catch((e: any) => {
            console.log(e?.response?.message);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTranslation, isProductDlc, listProductRelated, listCategories, id]);

  // scroll to dlc
  useEffect(() => {
    if (!!to && !loading && window) {
      if (refTimeOutScroll.current) {
        window.clearTimeout(refTimeOutScroll.current);
      }
      refTimeOutScroll.current = setTimeout(() => {
        refTimeOutScroll.current = undefined;
        const downloadable: any = document.querySelector('.store-games-detail-download-ble');
        if (downloadable) {
          const top = downloadable?.offsetTop || 0;
          window.scrollTo({top, behavior: 'smooth'});
        }
      }, 300);
    }

    return () => {
      window.clearTimeout(refTimeOutScroll.current);
    };
  }, [to, loading]);

  const handleGetInventoryLocation = (listInventoryLocation: any[]) => {
    let result = 0;

    if (!listInventoryLocation?.length) {
      return result;
    }
    const currencyCode = (getCookie('currentToken') as string) || 'SGD';
    if (currencyCode === 'SGD') {
      return 0;
    }
    const inventory_location_for_locale = listInventoryLocation.find(
      (item: any) => item?.currencyCode === currencyCode
    );
    if (inventory_location_for_locale) {
      result = inventory_location_for_locale.inventory;
    }
    return result;
  };

  const handleFormatListThumbnail = (videos: any[], images: any[]) => {
    const newListThumbnail: any = [];
    if (videos?.length) {
      videos.map(item => {
        const itemVideo = {
          id: newListThumbnail.length + 1,
          hrefImg: `https://i.ytimg.com/vi/${item?.video_id}/hq720.jpg`,
          typeImg: 'video',
          idVideo: item?.video_id,
        };
        newListThumbnail.push(itemVideo);
      });
    }
    if (images?.length) {
      images
        .sort((a, b) => a.sort_order - b.sort_order)
        .map(item => {
          const itemImage = {
            id: newListThumbnail.length + 1,
            hrefImg: item?.url_zoom || '',
            typeImg: 'image',
          };
          newListThumbnail.push(itemImage);
        });
    }
    refLengthListThumbnail.current = newListThumbnail?.length || 0;
    setListThumbnail(
      newListThumbnail?.length
        ? newListThumbnail
        : [
            {
              id: 1,
              hrefImg: PLACEHOLDER_IMG || '',
              typeImg: 'image',
            },
          ]
    );
  };

  const handleFormatTablist = (
    isDLC?: boolean,
    isFeatured?: boolean,
    isPreOrder?: boolean,
    isSoldOut?: boolean,
    highest_discount?: number
  ) => {
    const listTabs: any = {
      isDLC: {title: dataTranslation['estore-products-tab-dlc'], color: '#1E1E1E'},
      isFeatured: {title: dataTranslation['estore-products-tab-featured'], color: '#00B0B8'},
      isPreOrder: {title: dataTranslation['estore-products-tab-pre-order'], color: '#0169B2 '},
      isSoldOut: {title: dataTranslation['estore-products-tab-sold-out'], color: '#737373  '},
      // discount: {
      //   title: `${edition ? '' : dataTranslation['estore-product-sale-up-to' || '']} ${Math.floor(
      //     highest_discount || 0
      //   )}% ${dataTranslation?.['estore-products-tab-off']}`,
      //   color: '#DF4662',
      // },
      discount: {
        title: `${dataTranslation?.['news-tag-sale']}`,
        color: '#DF4662',
      },
    };
    const result: any = [];
    if (isDLC) {
      result.push(listTabs?.isDLC);
    }
    if (isFeatured) {
      result.push(listTabs?.isFeatured);
    }
    if (isPreOrder) {
      result.push(listTabs?.isPreOrder);
    }
    if (highest_discount) {
      result.push(listTabs.discount);
    }
    if (isSoldOut) {
      result.push(listTabs?.isSoldOut);
    }
    return result;
  };

  const handleFormatPlatform = (option: any, isDlc?: boolean): any[] => {
    const option_values = option?.option_values || [];
    const result: any[] = [];
    let indexPlatformDefault: any = null;
    if (option_values?.length) {
      option_values.map((item: any, index: number) => {
        if (item?.is_default) {
          indexPlatformDefault = index;
        }
        const newOption = {
          titleIcon: item?.label,
          value: handleFormatValuePlatform(item?.label || ''),
          id: item?.id,
        };

        result.push(newOption);
      });
    }
    const idPlatform =
      indexPlatformDefault !== null ? result[indexPlatformDefault]?.id : result[0]?.id;
    // const titlePlatform =
    //   indexPlatformDefault !== null ? result[indexPlatformDefault]?.value : result[0]?.value;
    setPlatform(isDlc ? '' : idPlatform);
    // setPlatformTitle(isDlc ? '' : titlePlatform);
    return result;
  };

  const handleFormatType = (type: any): any[] => {
    const option_values = type?.option_values || [];
    const result: any[] = [];
    if (option_values?.length) {
      option_values.map((item: any) => {
        if (item?.is_default) {
          setType(item?.id);
        }
        const newOption = {
          titleType: dataTranslation[`${item?.label}`.toLowerCase()] || '',
          value: (item?.label || '').toLowerCase(),
          id: item?.id,
        };
        result.push(newOption);
      });
    }
    return result;
  };

  const handelReturnVariantId = (edi?: any) => {
    let result = '';
    let newEdition: any = edi || edition;
    if (!newEdition) {
      newEdition = priceEditionList?.[0]?.id;
    }

    variants.map((item: any) => {
      if (!type) {
        if (item?.edition_id === newEdition && item?.platform_id === platform && !result) {
          result = item?.id;
        }
      } else {
        if (
          item?.edition_id === newEdition &&
          item?.platform_id === platform &&
          item?.type_id === type &&
          !result
        ) {
          result = item?.id;
        }
      }
    });
    return result;
  };

  const handleCheckInventoryLevel = (listCart: any[]) => {
    const variant_id = handelReturnVariantId(edition);
    const itemInCart = listCart.find((item: any) => item?.variant_id === variant_id);
    if (itemInCart) {
      setMaxItemOrder(itemInCart.inventory_level - (itemInCart.quantity || 0));
    } else {
      setMaxItemOrder(5);
    }
  };

  const handleSelectEditionValue = (value: any) => {
    setEdition(value);
    if (priceEditionList?.length) {
      const itemPrice = priceEditionList.find((item: any) => item.id === value);
      if (itemPrice) {
        setPrice(itemPrice.valuePrice);
        setSalePrice(itemPrice.defaultPrice);
      }
    }
    // check set setMaxItemOrder;
    let result: any = 5;
    let variantForEdiTion: any = '';
    variants.map((item: any) => {
      if (type) {
        if (
          item?.edition_id === value &&
          item?.platform_id === platform &&
          item?.type_id === type
        ) {
          if (
            item?.purchasing_disabled &&
            !item?.sku?.includes('http') &&
            item?.type_label !== 'Digital'
          ) {
            result = '0';
            return;
          }

          result = item?.inventory_level !== 0 ? item?.inventory_level || 5 : '0';
          variantForEdiTion = item;
        }
      } else {
        if (item?.edition_id === value && item?.platform_id === platform) {
          if (item?.purchasing_disabled) {
            result = '0';
            return;
          }

          result = item?.inventory_level !== 0 ? item?.inventory_level || 5 : '0';
          variantForEdiTion = item;
        }
      }
      setMpnSku(variantForEdiTion?.sku || '');
    });

    setHighestDiscount(variantForEdiTion?.highest_discount || 0);
    if (!listCartData?.length) {
      setMaxItemOrder(result);
      return;
    }
    const variant_id = handelReturnVariantId(value);
    const itemInCart = listCartData.find(
      (item: any) => item?.variant_id === variant_id || item?.variants_id === variant_id
    );
    if (itemInCart) {
      setMaxItemOrder(itemInCart.inventory_level - itemInCart.quantity);
    } else {
      setMaxItemOrder(result);
    }
  };

  const handleCallApiAddItemToCart = (newData: any, callback: (value: any) => void) => {
    // not cart
    if (!listCartData?.length) {
      cartApi
        .createCard(newData)
        .then((res: any) => {
          if (res?.status !== 200) {
            throw res;
          }

          const {physical_items} = res.data?.data?.line_items;
          if (Array.isArray(physical_items) && physical_items?.length) {
            dispatch(addListCart(physical_items));
          }

          setStateAdded(true);
          handleCheckInventoryLevel(physical_items);
          refTimeOut.current = setTimeout(() => {
            setStateAdded(false);
            setDisableBtn(false);
            setLoadingBtnAddCart(false);
          }, 3000);
        })
        .catch(() => {
          setDisableBtn(false);
          setLoadingBtnAddCart(false);
          setLoadingBtnBuyNow(false);
          callback?.({status: true});
        });
      return;
    }

    cartApi
      .addItemToCard(newData)
      .then((res: any) => {
        if (res?.status !== 200) {
          throw res;
        }
        const {physical_items} = res.data?.data?.line_items;
        if (Array.isArray(physical_items) && physical_items?.length) {
          dispatch(addListCart(physical_items));
        }

        setStateAdded(true);
        refTimeOut.current = setTimeout(() => {
          setStateAdded(false);
          setDisableBtn(false);
          setLoadingBtnAddCart(false);
        }, 3000);
        handleCheckInventoryLevel(physical_items);

        // if (!isLoginSuccess) {
        //   route.push('/login?ck=true');
        //   return;
        // }
        // cartApi
        //   .checkoutCart((getCookie('token') as string) ?? '')
        //   .then(response => {
        //     if (response.status !== 200) {
        //       throw response;
        //     }
        //     if (response?.data?.url) {
        //       window.location.href = response?.data?.url;
        //     }
        //   })
        //   .catch(() => {
        //     setLoadingBtnBuyNow(false);
        //   });
      })
      .catch(() => {
        setCookie('cartToken', '');
        setDisableBtn(false);
        setLoadingBtnAddCart(false);
        setLoadingBtnBuyNow(false);
        callback?.({status: true});
      });
  };

  const handleClickAddToCard = (callback: (value: any) => void) => {
    const currencyCode = (getCookie('currentToken') as string) || 'SGD';
    setDisableBtn(true);
    setLoadingBtnAddCart(true);
    const newData = {
      item: {
        product_id: id * 1,
        variant_id: handelReturnVariantId(),
        quantity: qty,
      },
      currencyCode,
    };
    handleCallApiAddItemToCart(newData, callback);
  };

  const handleClickBuyNow = (callback: (value: any) => void) => {
    setDisableBtn(true);
    setLoadingBtnBuyNow(true);
    const currencyCode = (getCookie('currentToken') as string) || 'SGD';
    const newData = {
      product_id: id,
      quantity: qty,
      variant_id: handelReturnVariantId(),
      currencyCode,
    };
    if (getCookie('isLoginSuccess') && getCookie('isLoginSuccess') === true) {
      cartApi
        .buyNow(newData)
        .then(res => {
          if (res?.status !== 200) {
            throw res;
          }
          if (`${locale}`.toLowerCase() === 'tc') {
            //@ts-expect-error
            const drCheckout = new DigitalRiverCheckout(process.env.NEXT_PUBLIC_DR_PUBLIC_KEY);
            const bcCartId = res?.data?.cartId || '';
            if (bcCartId) {
              drCheckout
                .createCheckoutSessionWithUpstreamToken({
                  upstreamToken: bcCartId,
                  shoppingCountry: currencyCode === 'TWD' ? 'TW' : 'HK',
                  currency: currencyCode,
                })
                .then((checkoutSession: any) => {
                  drCheckout.createModal(checkoutSession.id, {
                    ...handelRenderConfigDigitalRiverCheckout(`${currencyCode}`),
                    onCheckoutComplete: (order: any) => {
                      setDisableBtn(false);
                      setLoadingBtnBuyNow(false);
                    },
                    onClose: () => {
                      setDisableBtn(false);
                      setLoadingBtnBuyNow(false);
                    },
                  });
                })
                .catch((err: any) => {
                  console.log(err);
                });
            }
            return;
          }
          const url = res?.data?.url;
          if (url) {
            window.location.href = url;
          }
        })
        .catch(() => {
          callback?.({status: true});
        });
      return;
    }
    route.push(`/login?by_now=true&item=${JSON.stringify(newData)}`);
  };

  const handleClickBuyNowDigital = () => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      // if (typeof gtag !== 'undefined') {
      //   // @ts-ignore
      //   gtag('event', 'click', {
      //     event_category: 'Outbound Link',
      //     event_action: 'Click',
      //     elementUrl: mpnSku,
      //     outbound: true,
      //     dr: 'https://www.google.com/',
      //     dt: title,
      //   });
      // }
      // window.open(mpnSku);
    }
  };

  const handleCheckDisable = (pl: any, vari: any[]) => {
    const listVariantForPlatForm = cloneDeep(vari.filter((item: any) => item?.platform_id === pl));
    if (!listVariantForPlatForm?.length) {
      return true;
    }

    if (listCartData?.length) {
      listCartData.map((item: any) => {
        listVariantForPlatForm.map((itemV: any, index: number) => {
          if (itemV.id === item.variants_id) {
            listVariantForPlatForm[index].inventory_level =
              listVariantForPlatForm[index].inventory_level - item?.quantity >= 0
                ? listVariantForPlatForm[index].inventory_level - item?.quantity
                : 0;
          }
        });
      });
    }

    let result = true;
    listVariantForPlatForm.map((item: any) => {
      if (
        item?.sku?.includes('http') ||
        item?.inventory_level !== 0 ||
        item?.type_label === 'Digital'
      ) {
        result = false;
      }
    });
    return result;
  };

  //check render platform
  const handleCheckRenderPlatform = (pl: any[], vari: any[]) => {
    if (!vari?.length || !pl?.length) {
      return [];
    }
    const result = pl.map((item: any) => {
      return {
        ...item,
        isDisable: handleCheckDisable(item.id, vari),
      };
    });
    return result;
  };

  const handleRenderEditionForPlatform = (idPlatform: any, type?: any) => {
    if (isProductDlc) return;

    if (!variants?.length) {
      setPrice(`${handleRenderPrice('00.00', null, locale)}`);
      setPriceEditionList([]);
      return;
    }

    const newVarianForPlatform = variants.filter((item: any) => {
      if (type) {
        return item?.platform_id === idPlatform && item?.type_id === type;
      }
      return item?.platform_id === idPlatform;
    });
    const result: any[] = [];
    const listEdition: any[] = [];

    if (!newVarianForPlatform?.length) {
      setPrice(`${handleRenderPrice('00.00', null, locale)}`);
      setPriceEditionList([]);
      setEdition('');
      return;
    }

    newVarianForPlatform
      // .sort((a: any, b: any) => {
      //   if (a.price > b.price) {
      //     return 1;
      //   } else {
      //     return -1;
      //   }
      // })
      .map(item => {
        const newEdition = {
          titleEdition: item?.editon_label,
          valuePrice: `${handleRenderPrice(item?.sale_price || '00', null, locale)}`,
          defaultPrice: `${handleRenderPrice(item?.default_price || '00', null, locale)}`,
          id: item?.edition_id,
          isDisable:
            item?.type_label === 'Digital' || item?.sku?.includes('http')
              ? false
              : item?.inventory_level === 0,
          highest_discount: item?.highest_discount || 0,
        };
        listEdition.push(newEdition);
      });

    setPrice(`${listEdition?.[0]?.valuePrice || '00'}`);
    setHighestDiscount(listEdition?.[0]?.highest_discount || 0);
    setSalePrice(`${listEdition?.[0]?.defaultPrice || '00'}`);
    if (!listCartData?.length) {
      setPriceEditionList(listEdition);
      return;
    }
    listEdition.map((item: any) => {
      const idVariant = handelReturnVariantId(item.id);
      const itemForVariant = listCartData.find((cart: any) => cart?.variants_id === idVariant);
      if (!itemForVariant) {
        result.push(item);
        return;
      }
      if (
        itemForVariant?.inventory_level <= itemForVariant?.quantity &&
        !(itemForVariant?.type_label === 'Digital') &&
        !itemForVariant?.sku?.includes('http')
      ) {
        result.push({
          ...item,
          isDisable: true,
        });
        return;
      }
      result.push(item);
    });

    setPriceEditionList(result);
    setEdition('');
  };

  const handleSelectQty = (v: any) => {
    setQty(v);
  };

  const handelReturnGiftForVariantId = (id?: any) => {
    if (!id) return null;
    const freeGift = variants.length
      ? variants.find((item: any) => item.id === id)?.free_gift || {}
      : {};
    if (!Object.keys(freeGift)?.length || !freeGift?.inventory?.aggregated?.availableToSell) {
      return {
        title: dataTranslation['estore-products-detail-title-free-gift'] || 'Free gift',
        description: '',
        imgGift: PLACEHOLDER_IMG,
        titleGift: '',
        titleTab: '',
        isOfGift: false,
        isShowGift: false,
      };
    }
    return {
      title: dataTranslation['estore-products-detail-title-free-gift'] || 'Free gift',
      description: freeGift?.description || '',
      imgGift: freeGift?.defaultImage?.urlOriginal || PLACEHOLDER_IMG,
      titleGift: freeGift?.name || '',
      titleTab: '',
      isOfGift: false,
      isShowGift: true,
    };
  };

  const handleReturnGift = () => {
    if (!edition) {
      return {
        title: '',
        description: '',
        imgGift: PLACEHOLDER_IMG,
        titleGift: '',
        titleTab: '',
        isOfGift: false,
        isShowGift: false,
      };
    }
    const variantID = handelReturnVariantId(edition);
    return handelReturnGiftForVariantId(variantID);
  };

  const handelReturnListType = (p?: any) => {
    const result: any[] = [];
    if (!!`${p || platform}` && !!variants?.length) {
      const listVariantForPlatform = variants.filter((item: any) => item.platform_id === platform);
      if (!listVariantForPlatform.length || !listType.length) {
        return result;
      }

      listVariantForPlatform.map((item: any) => {
        const typeItem = listType.find(
          (type: any) => type.value === item?.type_label?.toLowerCase()
        );
        const hadItem = typeItem ? result.includes(typeItem) : true;

        if (typeItem && !hadItem && item?.type_label?.toLowerCase() === 'physical') {
          result[0] = typeItem;
        }
        if (typeItem && !hadItem && item?.type_label?.toLowerCase() === 'digital') {
          result[1] = typeItem;
        }
        // if (item?.type_label?.toLowerCase() === 'physical') {
        //   result[0] = listType[0];
        // }
        // if (item?.type_label?.toLowerCase() === 'digital') {
        //   result[1] = listType[1];
        // }
      });
    }
    return result.filter((item: any) => !!item);
  };

  const handleCheckType = () => {
    const newListType = handelReturnListType();
    if (newListType.length) {
      if (newListType.length === 1) {
        const itemType = newListType.find((item: any) => item?.value === 'digital');
        if (itemType) {
          return true;
        }
      }
      const itemType = newListType.find((item: any) => item?.id === type);
      if (itemType && itemType?.value === 'digital') {
        return true;
      }
    }

    if (mpnSku?.includes('http')) {
      return true;
    }
    return false;
  };

  const handleSelectType = (v: any) => {
    setType(v?.id || '');
    // setTypeTitle(v?.value || '');
    setMaxItemOrder(5);
    if (variants.length) {
      const newVariants = variants.filter(
        (item: any) => item?.platform_id === platform && item?.type_id === v?.id
      );
      if (!!newVariants && newVariants?.length === 1) {
        setMpnSku(newVariants[0]?.sku || '');
      }
    }
  };

  const handleSelectPlatform = (v: any) => {
    setMaxItemOrder(5);
    setType('');
    // setTypeTitle('');
    setMpnSku('');
    if (!isProductDlc) {
      setPlatform(v?.id);
      // setPlatformTitle(v?.value);
      return;
    }
    let result: any = '';
    let skuItem: any = '';
    if (variants.length) {
      variants.map((item: any) => {
        if (item?.platform_id === v?.id) {
          result = item?.price;
          skuItem = item?.mpn || item?.sku;
        }
      });
    }
    setMpnSku(skuItem);
    setPrice(`${handleRenderPrice(result || '00', null, locale)}`);
  };

  const handleHidePriceDigitalType = () => {
    const typeValue = handelReturnListType().find(item => item?.id === type);

    if (typeValue?.value === 'digital') {
      return true;
    }

    return false;
  }

  const handleReturnPrice = (priceValue: any, qtyValue = 1) => {
    const isHidePrice = handleHidePriceDigitalType();
    if (isHidePrice) {
      return '';
    }

    let newValue: any = priceValue;
    ['₱', 'Rp', 'RM', 'S$', '฿', 'HKD', 'TWD', 'KRW', 'NTD', '₩', '원'].map(
      (item: string) => (newValue = newValue.replace(item, ''))
    );
    return handleRenderPrice(`${newValue.replace(/,/g, '') * qtyValue}`, null, locale);
  };

  const wrapperEditionList = (editionList: any[]) => {
    if (!editionList?.length) {
      return;
    }

    const isHidePrice = handleHidePriceDigitalType();

    return editionList.map((item: any) => {
      return {
        ...item,
        valuePrice: isHidePrice ? '' : item?.valuePrice,
      };
    });
  }

  useEffect(() => {
    setQty(1);
    if (!variants?.length) {
      return;
    }
    handleRenderEditionForPlatform(platform, type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platform, type, variants]);

  //clear up
  useEffect(() => {
    const duplicateId = productListRecentlyID.includes(refId.current || '');
    if (!duplicateId) {
      dispatch(setProductListRecentlyID([refId.current]));
    }
    return () => {
      window.clearTimeout(refTimeOut.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deSlug, refId.current]);
  const thumbnailImageUrl = dataGame?.images?.[0]?.url_standard || '';
  const SeoStandard = {
    __typename: 'SeoStandard',
    seoTitle:
      title ||
      (`${locale}`.toLowerCase() === 'tc'
        ? '遊戲作品'
        : `${locale}`.toLowerCase() === 'ko-kr'
        ? '게임'
        : 'Games'),
    seoDescription: dataGame?.seo?.metaDescription || '',
    seoImage: thumbnailImageUrl,
    seoRobots: null,
    ogTitle:
      title ||
      (`${locale}`.toLowerCase() === 'tc'
        ? '遊戲作品'
        : `${locale}`.toLowerCase() === 'ko-kr'
        ? '게임'
        : 'Games'),
    ogDescription: dataGame?.seo?.metaDescription || '',
    ogImage: thumbnailImageUrl,
    seoKeywords: dataGame?.seo?.metaKeywords || '',
    seoAuthor: '',
    seoPublisher:
      `${locale}`.toLowerCase() === 'tc'
        ? '萬代南夢宮娛樂'
        : `${locale}`.toLowerCase() === 'ko-kr'
        ? '반다이남코 엔터테인먼트 코리아'
        : 'Bandai Namco Entertainment Asia',
  };

  return (
    <Box>
      <BlockRenderer block={[SeoStandard]} />
      {typeof window && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          {!loading && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <EStoreProductDetail
                buttonPropsBuyNowDigital={{
                  variant: 'primaryDark',
                  onClick: handleClickBuyNowDigital,
                  externalLink: mpnSku,
                  target: '_blank',
                  id: title,
                }}
                buttonPropsAddCart={{
                  label: dataTranslation['estore-products-detail-button-title-add-to-card'],
                  variant: 'secondary',
                }}
                buttonPropsBuyNow={{
                  label: !isPreOrder
                    ? dataTranslation['estore-products-detail-button-title-buy-now']
                    : dataTranslation['estore-product-detail-title-btn-pre-order-now'],
                  variant: 'primaryDark',
                }}
                buttonPropsBuyDLC={{
                  variant: 'primaryDark',
                  onClick: handleClickBuyNowDigital,
                }}
                options={{
                  ...optionsData,
                  locale: locale,
                  tabList: handleFormatTablist(
                    isProductDlc,
                    isFeatured,
                    isPreOrder,
                    isSoldOut,
                    highestDiscount
                  ),
                  titleAdded: dataTranslation['estore-product-detail-label-added'] || '',
                  platform: {
                    title: dataTranslation['game-detailed-game-info-release-platform'],
                    platformList: handleCheckRenderPlatform(platformList, variants),
                  },
                  typeOption: {
                    title: dataTranslation['estore-products-detail-title-type'],
                    typeList: handelReturnListType(),
                  },
                  typeEdition: {
                    ...optionsData?.typeEdition,
                    editionList: wrapperEditionList(priceEditionList),
                    titleCompare:
                      hadCompareEdition && !isSoldOut
                        ? dataTranslation['estore-products-detail-title-compare-edition'] ||
                          'Compare'
                        : '',
                  },
                  labelQty: dataTranslation['estore-order-detail-title-qty'],
                  quantity: handleCheckType() ? 1 : qty,
                  price: handleReturnPrice(price, qty),
                  salePrice: salePrice !== price ? salePrice : '',
                  titleSale: highestDiscount
                    ? `${highestDiscount}% ${dataTranslation['estore-products-tab-off'] || ''}`
                    : '',
                  isSelectTypeDigital: handleCheckType(),
                  loadingBtnAddCart,
                  loadingBtnBuyNow,
                  stateAdded,
                  maxItemOrder: handleCheckType() ? 5 : maxItemOrder < 0 ? 0 : maxItemOrder,
                  maxQuantity: maxItemOrder <= 0 ? '0' : maxItemOrder > 5 ? 5 : maxItemOrder,
                  helperTextNotEnough:
                    dataTranslation['estore-cart-quantity-card-helper-text-start'] || '',
                  helperTextQuantityLeft: dataTranslation['estore-text-quantity-left'] || '',
                  freeGift: handleReturnGift(),
                  onClickAddToCart: callback => (disableBtn ? {} : handleClickAddToCard(callback)),
                  onClickBuyNow: callback => (disableBtn ? {} : handleClickBuyNow(callback)),
                  titleTaxForTC: dataTranslation['estore-title-tax-for-tc'] || '',
                }}
                onSelectPlatform={handleSelectPlatform}
                onSelectType={handleSelectType}
                onSelectEdition={handleSelectEditionValue}
                onSelectQty={handleSelectQty}
                listThumbnail={listThumbnail}
                titleButtonBuyNowDigital={{
                  ps:
                    dataTranslation['estore-products-detail-title-button-buy-now-ps'] ||
                    'Buy now at PS Store',
                  steam:
                    dataTranslation['estore-products-detail-title-button-buy-now-steam'] ||
                    'Buy now at Steam',
                  xbox:
                    dataTranslation['estore-products-detail-title-button-buy-now-xbox'] ||
                    'Buy now at Xbox.com',
                  nintendo:
                    dataTranslation['estore-products-detail-title-button-buy-now-nintendo'] ||
                    'Buy now at Nintendo.com',
                }}
                isProductDlc={isProductDlc}
                isSoldOut={isSoldOut}
                labelBtnSoldOut={dataTranslation['estore-sold-out-text'] || ''}
              />
              {!isProductDlc && !loading && (
                <>
                  {/* {(slug === 'one-piece-odyssey' || slug === 'elden-ring') && (
                    <EStoreProductDetailCompareEditions
                      {...(slug === 'one-piece-odyssey' ? DATA_ONE_PIECE : DATA_ELDEN_RING)}
                      onClickBuyEdition={() => {}}
                    />
                  )} */}
                  {`${locale}`.toLowerCase() === 'ko-kr' && priceEditionList?.length < 2 ? (
                    ''
                  ) : (
                    <EStoreProductDetailCompareEditionsOrganisms
                      // platformTitle={platformTitle || ''}
                      // typeTitle={typeTitle || ''}
                      // editionList={handelRenderEditionListForPlatform(platform || '')}
                      sku={sku}
                      dataTranslation={dataTranslation}
                      onShowCompare={setHadCompareEdition}
                    />
                  )}
                  <EStoreProductDetailGameSpecsOrganisms
                    sku={sku}
                    description={description ?? ''}
                    dataTranslation={dataTranslation}
                  />
                </>
              )}
              {/* Describe game */}
              {isProductDlc && (
                <Box
                  sx={{
                    marginTop: {
                      xs: '-52px',
                      md: '0px',
                    },
                  }}
                >
                  <EStoreProductDetailAboutGameOrganisms
                    description={description}
                    dataTranslation={dataTranslation}
                  />
                </Box>
              )}
              {/* Downloadable content (DLC) */}
              {!!listProductDLC?.length && (
                <EStoreProductDetailDownloadableOrganisms
                  listProductDLC={listProductDLC}
                  title={title}
                  loading={loading}
                />
              )}
              {/* You may also like */}
              <EStoreYouMayLikeOrganisms
                title={dataTranslation?.['estore-title-section-you-may-also-like'] || ''}
                loading={loading}
                getById={true}
                listProduct={listProductGame}
              />

              {/* Recently viewed */}
              <EStoreProductDetailRecentlyOrganisms loading={loading} />
            </Box>
          )}

          <Box
            sx={{
              display: loading ? 'flex' : 'none',
              minHeight: '100vh',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                marginTop: '30vh',
              }}
            >
              <IconLoading />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const promises: [ReturnType<typeof getPageData>, ReturnType<typeof getGloablByType>] = [
    getPageData({slug: 'store', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
  ];
  const [pageData, seo] = await Promise.all(promises);
  const {data} = pageData;
  
  
  return {
    props: {
      data,
      seo,
      slug: ctx.query.slug,
    },
  };
};

export default ProductDetail;
